export default "__VITE_ASSET__CB2lX7FG__"